import { gql } from "@apollo/client"
import { JOB_FIELDS } from "../../jobs/fragments/jobFieldsFragment"
import { KNOWLEDGE_FIELDS } from "../../knowledge"

const POST_FIELDS = gql`
  fragment PostFields on Post {
    id
    title
    content
    hasConfirm
    hasSentConfirms
    hasComments
    visibleFrom
    mediaUrl
    mediaUpload {
      id
      key
      fileName
      fileGroup
      fileSize
    }
    locations {
      id
      name
    }
    users {
      id
      fullName
    }
    groups {
      id
      name
    }
    uploads {
      id
      key
      fileName
      fileGroup
      fileSize
    }
    job {
      ...JobFields
    }
    knowledge {
      ...KnowledgeFields
    }
    confirmedCount
    unconfirmedCount
    currentUserNotification {
      id
      confirmed
    }
    author {
      id
      firstName
      lastName
      fullName
      avatar {
        key
      }
      activeAt
    }
    comments {
      id
      content
      uploads {
        id
        key
        fileName
        fileGroup
        fileSize
      }
      author {
        id
        firstName
        lastName
        avatar {
          key
        }
        activeAt
      }
      createdAt
      reactionSummaries {
        emoji
        count
        subsetUsers
        userHasReacted
      }
    }
    reactionSummaries {
      emoji
      count
      subsetUsers
      userHasReacted
    }
    createdAt
    updatedAt
    subHeader
    coverImage {
      id
      key
      fileName
      fileGroup
      fileSize
    }
    type
    startAt
    endAt
  }
  ${JOB_FIELDS}
  ${KNOWLEDGE_FIELDS}
`

const POST_FIELDS_SUMMARY = gql`
  fragment PostFieldsSummary on Post {
    id
    title
    content
    visibleFrom
    author {
      id
      firstName
      lastName
      fullName
      avatar {
        key
      }
      activeAt
    }
    locations {
      id
      name
    }
    users {
      id
      fullName
    }
    groups {
      id
      name
    }
    createdAt
    updatedAt
    subHeader
    coverImage {
      id
      key
      fileName
      fileGroup
      fileSize
    }
    type
    startAt
    endAt
  }
  ${JOB_FIELDS}
  ${KNOWLEDGE_FIELDS}
`

// Basic information to display campaign posts. Will hydrate with more details when needed.
const CAMPAIGN_POST_FIELDS = gql`
  fragment CampaignFields on Post {
    id
    title
    visibleFrom
    createdAt
    updatedAt
    subHeader
    coverImage {
      id
      key
      fileName
      fileGroup
      fileSize
    }
    type
    startAt
    endAt
  }
`

export { POST_FIELDS, POST_FIELDS_SUMMARY, CAMPAIGN_POST_FIELDS }
